




















import {Vue, Component} from 'vue-property-decorator';
import {Getter, namespace} from 'vuex-class';
import {ProjectsMetadata} from '../../../metadata/projects-metadata.d';

const MainGetter = namespace('main', Getter);

@Component
export default class MainProjects extends Vue {
  @MainGetter('availableProjects') private availableProjects: ProjectsMetadata;
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/main/projects/projects.vue